import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import FormContainer from '../components/FormContainer';
import API_BASE_URL from '../config/api';

const PRIORITY_MACHINES = [
  { key: 'SUPERSEEDER', label: 'Super Seeder' },
  { key: 'ROTAVATOR', label: 'Rotavator' },
  { key: 'MULCHER', label: 'Mulcher' },
  { key: 'RMBPLOUGH', label: 'RMB Plough' },
  { key: 'ZEROTILLDRILL', label: 'Zero Till Drill' },
  { key: 'ROTARYSLASHER', label: 'Rotary Slasher' },
  { key: 'PADDYSTRAWCHOPPER', label: 'Paddy Straw Chopper' },
  { key: 'BALER', label: 'Baler' },
  { key: 'RAKER', label: 'Raker' },
  { key: 'REAPER', label: 'Reaper' },
  { key: 'TRACTOR', label: 'Tractor' },
  { key: 'HAPPYSEEDER', label: 'Happy Seeder' },
  { key: 'SURFACESEEDER', label: 'Surface Seeder' }
];

const REMAINING_MACHINES = [
  { key: 'SMARTSEEDER', label: 'Smart Seeder' },
  { key: 'SUPERSMS', label: 'Super SMS' },
  { key: 'SHRUBMASTER', label: 'Shrub Master' },
  { key: 'CUTTERCUMSPREADER', label: 'Cutter Cum Spreader' },
  { key: 'TRACTORTROLLEY', label: 'Tractor Trolley' },
  { key: 'LASERLEVELLER', label: 'Laser Leveller' },
  { key: 'DIRECTSEEDERRICE', label: 'Direct Seeder Rice' },
  { key: 'MAIZEPLANTERMECHANICAL', label: 'Maize Planter Mechanical' },
  { key: 'MAIZEPLANTERVACCUM', label: 'Maize Planter Vacuum' },
  { key: 'SPRAYPUMP', label: 'Spray Pump' },
  { key: 'PRESSUREDISKS', label: 'Pressure Disks' },
  { key: 'DISKLOCK', label: 'Disk Lock' },
  { key: 'BIOFERTILIZERSPREADER', label: 'Bio Fertilizer Spreader' },
  { key: 'CULTIVATOR', label: 'Cultivator' },
  { key: 'SUBSOILER', label: 'Subsoiler' },
  { key: 'POWERCLEANER', label: 'Power Cleaner' },
  { key: 'DISCRAZOR', label: 'Disc Razor' },
  { key: 'HARROWTRIPPLE', label: 'Harrow Tripple' },
  { key: 'COTTONSEEDDRILL', label: 'Cotton Seed Drill' },
  { key: 'WATERTANK', label: 'Water Tank' },
  { key: 'SUHAGA', label: 'Suhaga' },
  { key: 'WHEATSEEDFAN', label: 'Wheat Seed Fan' },
  { key: 'SEEDGRINDINGMACHINE', label: 'Seed Grinding Machine' },
  { key: 'JINDRA', label: 'Jindra' },
  { key: 'COMBINE', label: 'Combine' },
  { key: 'SEELARCOTTON', label: 'Seelar Cotton' },
  { key: 'GENERATOR', label: 'Generator' },
  { key: 'WHEATSEEDDRILL', label: 'Wheat Seed Drill' },
  { key: 'PLOUGH', label: 'Plough' },
  { key: 'GROUNDLEVELLER', label: 'Ground Leveller' },
  { key: 'STRAWREAPER', label: 'Straw Reaper' },
  { key: 'POTATOPLANTER', label: 'Potato Planter' },
  { key: 'TAWIAN', label: 'Tawian' },
  { key: 'SIMPLELEVELLER', label: 'Simple Leveller' },
  { key: 'LOADER', label: 'Loader' },
  { key: 'POTATODRILL', label: 'Potato Drill' },
  { key: 'MULTIDRILLMACHINE', label: 'Multi Drill Machine' },
  { key: 'PUDDLER', label: 'Puddler' },
  { key: 'CHOPPER', label: 'Chopper' },
  { key: 'CORNDRILL', label: 'Corn Drill' },
  { key: 'PEASMACHINE', label: 'Peas Machine' },
  { key: 'SEEDDRILL', label: 'Seed Drill' },
  { key: 'CHIZLER', label: 'Chizler' },
  { key: 'PADDYPLANTER', label: 'Paddy Planter' },
  { key: 'DIESELTANK', label: 'Diesel Tank' },
  { key: 'BHAUNI', label: 'Bhauni' },
  { key: 'TOTA', label: 'Tota' },
  { key: 'TILLER', label: 'Tiller' },
  { key: 'KARAH', label: 'Karah' },
  { key: 'TARFALI', label: 'Tarfali' },
  { key: 'RAZOR', label: 'Razor' },
  { key: 'THRESHER', label: 'Thresher' },
  { key: 'KARCHAMACHINE', label: 'Karcha Machine' },
  { key: 'RATOR', label: 'Rator' },
  { key: 'SUGARCANERAGER', label: 'Sugar Cane Rager' },
  { key: 'DISCHARROW', label: 'Disc Harrow' },
  { key: 'CHAINKUPPI', label: 'Chain Kuppi' },
  { key: 'SUGARCANESEEDER', label: 'Sugar Cane Seeder' },
  { key: 'GRINDER', label: 'Grinder' },
  { key: 'CHANGER', label: 'Changer' },
  { key: 'TRIPPLEPLOUGH', label: 'Tripple Plough' },
  { key: 'CORNHARVESTER', label: 'Corn Harvester' },
  { key: 'CUTTER', label: 'Cutter' },
  { key: 'MOTORMACHINE', label: 'Motor Machine' },
  { key: 'DISCPLOUGH', label: 'Disc Plough' },
  { key: 'GAINIPLOUGH', label: 'Gaini Plough' },
  { key: 'DUGPLOUGH', label: 'Dug Plough' },
  { key: 'OFFSETHARROW', label: 'Offset Harrow' },
  { key: 'JAAL', label: 'Jaal' },
  { key: 'TARAKADI', label: 'Tarakadi' },
  { key: 'CARROTMACHINE', label: 'Carrot Machine' },
  { key: 'DISCBEDMAKER', label: 'Disc Bed Maker' },
  { key: 'LOADERBUCKET', label: 'Loader Bucket' },
  { key: 'SEEDGRADER', label: 'Seed Grader' },
  { key: 'ACHATHALL', label: 'Achathall' },
  { key: 'TAWAWATTA', label: 'Tawa Watta' },
  { key: 'JACK', label: 'Jack' }
];

const ALL_MACHINES = [...PRIORITY_MACHINES, ...REMAINING_MACHINES];

const AuthorizedMachineCountPage = ({ user }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const society = location.state?.society || null;

  const [actualCounts, setActualCounts] = useState({});
  const [authorizedCounts, setAuthorizedCounts] = useState({});
  const [period, setPeriod] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [toastMessage, setToastMessage] = useState('');

  useEffect(() => {
    if (!society) {
      navigate('/societies');
      return;
    }

    const fetchCounts = async () => {
      setLoading(true);
      try {
        const res = await fetch(`${API_BASE_URL}/api/machines/authorized-counts?societyId=${society._id}`);
        const data = await res.json();
        if (data.success) {
          setPeriod(data.period);
          setActualCounts(data.counts || {});
          setAuthorizedCounts(data.authorizedCounts || {});
        }
      } catch (err) {
        console.error('Error fetching authorized machine counts:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchCounts();
  }, [society, navigate]);

  const handleAuthCountChange = (key, value) => {
    const num = Math.max(0, parseInt(value, 10) || 0);
    setAuthorizedCounts(prev => ({
      ...prev,
      [key]: num
    }));
  };

  const handleSave = async () => {
    if (!society) return;
    setSaving(true);
    try {
      const res = await fetch(`${API_BASE_URL}/api/machines/authorized-counts`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          societyId: society._id,
          authorizedCounts
        })
      });
      const data = await res.json();
      if (data.success) {
        setToastMessage('✅ Authorized machine counts saved successfully!');
        setTimeout(() => {
          setToastMessage('');
          navigate('/societies');
        }, 1200);
      } else {
        alert(data.message || 'Error saving authorized counts');
      }
    } catch (err) {
      console.error('Save error:', err);
      alert('Failed to connect to backend server.');
    } finally {
      setSaving(false);
    }
  };

  if (!society) return null;

  const societyName = society.SOCIETY || society.SocietyName || 'Society';
  const titleText = period 
    ? `Authorized Machine Counts — ${societyName}`
    : `Authorized Machine Counts — ${societyName}`;

  return (
    <>
      {toastMessage && (
        <div className="toast-notification">
          <span>✅</span> {toastMessage}
        </div>
      )}
      <FormContainer
        title={titleText}
        onClose={() => navigate('/societies')}
        onCancel={() => navigate('/societies')}
        onSave={handleSave}
        saveText="Save"
        saving={saving}
      >

      {period && (
        <div style={{ marginBottom: '16px', fontSize: '13px', color: '#64748b', fontWeight: '500' }}>
          Period: <strong>{period.StartDate} to {period.EndDate}</strong> ({period.seasonName || period.PERIOD})
        </div>
      )}

      {/* Non-editable Society Acres and Members Summary */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
        gap: '16px',
        marginBottom: '20px'
      }}>
        <div style={{
          background: '#f8fafc',
          border: '1px solid #cbd5e1',
          borderRadius: '8px',
          padding: '12px 16px',
          display: 'flex',
          flexDirection: 'column',
          gap: '4px'
        }}>
          <span style={{ fontSize: '12px', fontWeight: '600', color: '#64748b' }}>Acres</span>
          <span style={{ fontSize: '16px', fontWeight: '700', color: '#1e293b' }}>
            {actualCounts.ACRES !== undefined ? actualCounts.ACRES : (society.ACRES || 0)}
          </span>
        </div>

        <div style={{
          background: '#f8fafc',
          border: '1px solid #cbd5e1',
          borderRadius: '8px',
          padding: '12px 16px',
          display: 'flex',
          flexDirection: 'column',
          gap: '4px'
        }}>
          <span style={{ fontSize: '12px', fontWeight: '600', color: '#64748b' }}>No. of Members</span>
          <span style={{ fontSize: '16px', fontWeight: '700', color: '#1e293b' }}>
            {actualCounts.NO_OF_MEMBERS !== undefined ? actualCounts.NO_OF_MEMBERS : (society.NO_OF_MEMBERS || 0)}
          </span>
        </div>
      </div>

      {loading ? (
        <p style={{ textAlign: 'center', padding: '40px', color: '#64748b' }}>
          Loading machine counts data...
        </p>
      ) : (
        <div style={{ border: '1px solid #e2e8f0', borderRadius: '8px', overflow: 'hidden', background: '#ffffff' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px', textAlign: 'left' }}>
            <thead>
              <tr style={{ background: '#f1f5f9', borderBottom: '1px solid #cbd5e1', color: '#334155' }}>
                <th style={{ padding: '12px 16px', fontWeight: '700', width: '50px' }}>#</th>
                <th style={{ padding: '12px 16px', fontWeight: '700' }}>Machine Name</th>
                <th style={{ padding: '12px 16px', fontWeight: '700', width: '200px', textAlign: 'center' }}>
                  Current Machine Count
                </th>
                <th style={{ padding: '12px 16px', fontWeight: '700', width: '240px', textAlign: 'center' }}>
                  Authorized Machine Count
                </th>
              </tr>
            </thead>
            <tbody>
              {ALL_MACHINES.map((m, idx) => {
                const actual = actualCounts[m.key] || 0;
                const authVal = authorizedCounts[m.key] !== undefined ? authorizedCounts[m.key] : 0;

                return (
                  <tr
                    key={m.key}
                    style={{
                      borderBottom: '1px solid #f1f5f9',
                      background: idx % 2 === 0 ? '#ffffff' : '#f8fafc'
                    }}
                  >
                    <td style={{ padding: '10px 16px', color: '#64748b' }}>{idx + 1}</td>
                    <td style={{ padding: '10px 16px', fontWeight: '600', color: '#1e293b' }}>
                      {m.label}
                    </td>
                    <td style={{ padding: '10px 16px', textAlign: 'center', fontWeight: '600', color: '#475569' }}>
                      <span style={{
                        background: '#e2e8f0',
                        padding: '4px 14px',
                        borderRadius: '12px',
                        fontSize: '12px'
                      }}>
                        {actual}
                      </span>
                    </td>
                    <td style={{ padding: '10px 16px', textAlign: 'center' }}>
                      <input
                        type="number"
                        min="0"
                        value={authVal}
                        onChange={(e) => handleAuthCountChange(m.key, e.target.value)}
                        style={{
                          width: '110px',
                          padding: '6px 10px',
                          borderRadius: '6px',
                          border: '1px solid #cbd5e1',
                          textAlign: 'center',
                          fontSize: '13px',
                          fontWeight: '600',
                          outline: 'none'
                        }}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </FormContainer>
    </>
  );
};

export default AuthorizedMachineCountPage;
